
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pro-buyer",
      function () {
        return require("private-next-pages/pro-buyer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pro-buyer"])
      });
    }
  